import _ from 'lodash';
import compareVersions from "compare-versions";
import { constantsActive } from "utils/constants/constants";
import store from 'services/redux/store'
import { dataConstants } from 'services/redux/data/constants'
import HelperVersion from 'utils/helper-version'

const ObjectVersion = {
	
	combineVersions: ( versions ) => {
		let versionsCombined = {};
		
		_.forEach( versions, version => {
			version.build_version = ObjectVersion.removeUnwanted( version.build_version );
			
			if( !_.has( versionsCombined, version.build_version ) ) {
				versionsCombined[ version.build_version ] = version.onboarding_shown === constantsActive.YES;
			}
			
			if( versionsCombined[ version.build_version ] !== true ) {
				versionsCombined[ version.build_version ] = version.onboarding_shown === constantsActive.YES;
			}
		})
		
		return versionsCombined;
	},
	
	versionsList: () => {
		return (
			{

			}
		);
	},
	
	mustShowUpdate: () => {
		const _employee = store.getState().data[ dataConstants.EMPLOYEE ];
		const lastVersion = _employee?.last_version
		
		if( !_.isEmpty( lastVersion ) ) {
			const currentVersion = ObjectVersion.getCurrentVersion();
			
			let mustShow = false;
			_.forEach( ObjectVersion.versionsList(), ( data, version ) => {
				if( compareVersions.compare( lastVersion.build_version, version, '<' ) && lastVersion.build_version !== currentVersion ) {
					mustShow = data;
					return false;
				}
			})
			
			return mustShow;
		}
		
		return false;
	},
	
	removeUnwanted: ( version ) => {
		return String( version ).replace('-test', '');
	},
	
	getCurrentVersion: () => {
		return ObjectVersion.removeUnwanted( HelperVersion.getBuildVersion() );
	},
}

export default ObjectVersion
